// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2qz4n","rootSmall":"AddTileButton_rootSmall__109hi"};